import "./contact_us.scss";

function ContactUs() {
  return (
    <div className="contact-us-wrapper">
      <p>网站使用问题请加Alex微信：17274623359</p>
      <p>商务合作同样也请加Alex微信：17274623359</p>
    </div>
  );
}

export default ContactUs;
